import { configService } from "@/services/config-service";

export const setupHubspot = async (hubspotRef?: HTMLElement) => {
  const hubspotScript = document.createElement("script");
  hubspotScript.setAttribute(
    "src",
    "//js.hs-scripts.com/" + configService.hubspotTrackingCode + ".js"
  );
  hubspotScript.setAttribute("type", "text/javascript");
  hubspotScript.setAttribute("id", "hs-script-loader");

  const hubRef = hubspotRef || document.body;
  hubRef.appendChild(hubspotScript);
};
